import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    });
    script.setAttribute('data-schema', type);
    document.head.appendChild(script);
    return () => {
      const existing = document.head.querySelector(`script[data-schema="${type}"]`);
      if (existing) existing.remove();
    };
  }, [type, JSON.stringify(data)]);

  return null;
}